import { createStyles, makeStyles } from '@material-ui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    iconContainer: {
      marginBottom: theme.spacing(3),
    },
    icon: {
      fontSize: theme.spacing(5),
    },
  })
);

export default useStyles;
